import type { NotificationType } from '@src/types/notification';
import { SvelteMap } from 'svelte/reactivity';
import { v4 as uuidv4 } from 'uuid';

export const notifications: SvelteMap<string, NotificationType> = $state(new SvelteMap());
export const oldNotifications: SvelteMap<string, NotificationType> = $state(new SvelteMap());

// Function to add a notification to the notifications store
export function addNotification(notification: NotificationType) {
	const uniqueItemId = uuidv4();

	// remove notification from 'active notifications' after timeout if autoDismiss is true
	if (notification.autoDismiss) {
		setTimeout(() => removeNotification(uniqueItemId), notification.timeout);
	}

	notifications.set(uniqueItemId, { ...notification, id: uniqueItemId });
}

// Function to remove a notification from the notifications store
export function removeNotification(id: string) {
	if (notifications.has(id)) {
		const removedNotification = notifications.get(id);
		// add removed notification to 'dismissed notifications' if it exists
		if (removedNotification) {
			oldNotifications.set(id, removedNotification);
		}
		// remove notification from 'active notifications'
		notifications.delete(id);
	}
}

// Function to get all notifications for a specific component id
export function getComponentNotifications(componentId: string) {
	return Array.from(notifications.values()).filter((notification) => notification.componentId === componentId);
}

export const notificationStore = {
	notifications: {
		get items() {
			return [...notifications];
		},
		addNotification,
		removeNotification,
		getComponentNotifications,
	},
};
